import React from 'react';

export default function Skills(){
  return (
    <div>
    <ul>
      <li>Angular</li>
      <li>Ngrx</li>
      <li>Python</li>
      <li>React</li>
      <li>React Router</li>
      <li>Redux</li>
      <li>Javascript</li>
      <li>Java</li>
      <li>Agile development</li>
    </ul>
    </div>
  )
}
